import { render, staticRenderFns } from "./Error.vue?vue&type=template&id=324b758f&scoped=true"
var script = {}
import style0 from "./Error.vue?vue&type=style&index=0&id=324b758f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324b758f",
  null
  
)

export default component.exports